export default "__VITE_ASSET__d4c3b249__"